import React, { useState } from 'react'
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { getTiposMaterialesAlmacenes } from 'services/TiposMaterialesService';


export default function BuscadorStock(props){
    const {getTiposMaterialesAlmacenes, traerMateriales, setMateriales, AlmacenId} = props
    const [query, setQuery] = useState("");

    const cambiarQuery = event => {
        setQuery(event.target.value);
      };
    
      const Buscar = async()=>{
        let params = {idAlmacen: AlmacenId? AlmacenId : '', query_result:query}
        let result = await getTiposMaterialesAlmacenes(params)
        if(result != null){
            setMateriales(result.tma);
        }else{alert("no se pudo buscar"); traerMateriales()}
        }

    const atras=() =>{
        traerMateriales()
    setQuery("");
    }  

    const keyDownFunction =(event) => {
        if (event.keyCode === 13) {
            Buscar();
        }
      }
    

    return(
        <>
        <InputGroup>
        <Input placeholder="Buscar" type="text" 
            value={query} 
            onChange={cambiarQuery}
            onKeyDown={(e)=>keyDownFunction(e)}
        />
        <InputGroupAddon addonType="append">
            <Button className="ml-3" color="success" outline type="button" onClick={()=>Buscar()}>
            Buscar
            </Button>
            <Button className="ml-3" color="success" outline type="button" onClick={()=>atras()}>
            Atras
            </Button>
        </InputGroupAddon>
        </InputGroup>
        </>
    )
}